/**
 * Query key factory for the triggers
 */
export const triggersQueryKeys = {
  all: (orgId: string) => ["triggers", orgId] as const,
  list: (orgId: string) => [...triggersQueryKeys.all(orgId), "list"] as const,

  // Not under an org. A trigger id is unique across every org, and the
  // by-id read authorizes against that trigger's own org whichever org is
  // selected, so an id is the same response for every selected org.
  byId: (triggerId: string) => ["triggers", "byId", triggerId] as const,

  dispatches: (orgId: string, triggerId: string) =>
    [...triggersQueryKeys.all(orgId), "dispatches", triggerId] as const,

  datasetDispatches: (orgId: string, datasetId: string) =>
    [...triggersQueryKeys.all(orgId), "datasetDispatches", datasetId] as const,

  // Samples are the same for every org, but the key still hangs off `all` so
  // the convention holds and a sign-out invalidates them with everything else.
  eventSamples: (orgId: string) =>
    [...triggersQueryKeys.all(orgId), "eventSamples"] as const,
};
